<template>
  <div id="app" :class="bodyClass">
    <div class="center-everything" v-if="user === false">
      <loader />
    </div>
    <div v-else class="wrapper">
      <navbar v-if="user" />
      <mobile-navbar v-if="user" />
      <router-view />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import MobileNavbar from "@/components/MobileNavbar";
import Loader from "@/components/Loader";
import { mapState } from "vuex";

export default {
  components: {
    Loader,
    Navbar,
    MobileNavbar
  },
  data() {
    return {
      bodyClass: "body-dna"
    };
  },
  computed: {
    ...mapState(["user", "companies", "company"])
  },
  async created() {
    // if (this.user) {
    //   await this.$store.dispatch("FETCH_COMPANIES");
    // }
    await this.$store.dispatch("INIT_USER");
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/styles.scss";

.center-everything {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
